import React, { useState, useRef, useEffect, useReducer } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import FastfoodOutlinedIcon from '@mui/icons-material/FastfoodOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
// Icons
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Iconify from '../../components/iconify/Iconify';

import { Box, Card, Link, Typography, Stack, Button, InputAdornment, TextField, ListItemIcon, Container } from '@mui/material';

const ActionButtons = ({ onUpdateVarint, onDeleteVariant, variant, }) => (
    <>
        <Button variant='text' onClick={() => onUpdateVarint(variant)}>
            <ListItemIcon >
                <EditIcon sx={{ color: 'blue' }} />
            </ListItemIcon>
        </Button>
        <Button variant='text ' onClick={() => onDeleteVariant(variant)}>
            <ListItemIcon>
                <DeleteIcon sx={{ color: 'red' }} />
            </ListItemIcon>
        </Button>
    </>

);

const VariantTable = (props) => {
    const { variants, onUpdateVarint, onDeleteVariant, onAddVariant, } = props



    return (
        <>
            {/* <Stack sx={{ alignItems: 'end', marginBottom: '20px' }}>
               
            </Stack> */}

            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell >Kg</TableCell>
                            <TableCell align="right">Stock</TableCell>
                            <TableCell align="right">Mrp</TableCell>
                            <TableCell align="right">Cost</TableCell>
                            <TableCell align="center">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {variants?.map((item) => (
                            <TableRow key={item.id}>
                                <TableCell align="end"> {item.name}</TableCell>
                                <TableCell align="right"> {item.stock}</TableCell>
                                <TableCell align="right"> {item.mrp}</TableCell>
                                <TableCell align="right">{item.cost}</TableCell>
                                <TableCell align='right'><ActionButtons variant={item} onUpdateVarint={onUpdateVarint} onDeleteVariant={onDeleteVariant} /></TableCell>
                            </TableRow>
                        ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>



        </>
    )
}

export default VariantTable